import React from 'react';
import '../../App.css';
import { Link } from 'react-router-dom';
// import Cards from '../Cards';
// import HeroSection from '../HeroSection';
// import Footer from '../Footer';

function Giving() {
  return (
    <>
    <div className='hero-container giving half'>
        <h1>Giving</h1>
        </div>
      <iframe src="https://give.tithe.ly/?formId=6096ac72-6865-11ee-90fc-1260ab546d11" className='tithely-frame'></iframe>
      {/* <div className='main'>
        <p>To give to Grace Community Fellowship, please go to our page on the <Link to="https://tithe.ly/give?c=4711162">Tithely website.</Link></p>
        </div> */}
    </>
  );
}

export default Giving;